import React, { Component } from 'react';
import { Container } from 'flux/utils';
import SystemTaskStore from '../../stores/SystemTaskStore';
import SystemTaskJobStore from '../../stores/SystemTaskJobStore';
import TaskActions from '../../actions/SystemTaskActionCreator';
import TableView from '../Common/TableView';
import SystemTaskJobRow from './SystemTaskJobRow';

class SystemTaskJobs extends Component {

    componentWillMount() {
        this.setState({id: Number(this.props.routeParams.taskId)});
    }

    componentDidMount() {
        TaskActions.getTask(this.state.id);
        TaskActions.getJobs(this.state.id);
    }

    render() {
        const headers = ["Scheduled", "Started", "Finished", "Status", "Automatic"];

        return (
            <TableView
                backButton={true}
                title={!this.state.task ? "Task jobs" : `${this.state.task.name}`}
                headers={headers}
                fixedHeader={true}
                rows={this.state.jobs}
                decorator={SystemTaskJobRow}
            />
        );
    }
}

SystemTaskJobs.getStores = () => ([SystemTaskStore, SystemTaskJobStore]);
SystemTaskJobs.calculateState = prevState => {
    const id = prevState && prevState.id;
    return {
        id,
        isFetching: SystemTaskJobStore.isFetching(),
        task: (!!id ? SystemTaskStore.getTask(id) : {}),
        jobs: (!!id ? SystemTaskJobStore.getJobs(id) : []),
        idLimits: (!!id ? SystemTaskJobStore.getIdLimits(id) : {})
    };
};

export default Container.create(SystemTaskJobs);
